//----------------------------------------------------------------------------------------------------------------------
// ID Generation Utility
//----------------------------------------------------------------------------------------------------------------------

import { hexoid } from 'hexoid';

//----------------------------------------------------------------------------------------------------------------------

/**
 * Fast, unique ID generator for entities.
 * Uses hexoid for high-performance ID generation (~200M IDs/sec).
 * Generates 16-character hexadecimal strings.
 *
 * @example
 * ```typescript
 * const id = generateId(); // "8cd88e1a9b13aac0"
 * ```
 */
export const generateId = hexoid(16);

//----------------------------------------------------------------------------------------------------------------------
